<template>
  <v-autocomplete dense outlined v-model="modelData" :label="placeholder" :name="name"
    :items="!sobrescreverOption ? listaDeOptions : listaDeOptionsAuxiliar" :item-text="optionLabel"
    :item-value="optionValue" :disabled="somenteLeitura" :autoSelectFirst="autoSelectFirst" :clearable="limpavel"
    :multiple="selecaoMultipla" :chips="selecaoMultipla ? formatoBotao : false" :deletable-chips="formatoBotaoExcluir"
    :error-messages="error" @update:search-input="$emit('update:search-input', $event)" @blur="parseValue"
    @change="handleChange" :class="error ? 'show-errors' : 'hide-error'" placeholder="Selecione" :loading="loadingProp"
    :editable="editar">
    <template v-slot:progress>
      <v-progress-circular indeterminate :width="3" :size="28" color="primary"></v-progress-circular>
    </template>

    <template v-slot:prepend-item v-if="selecaoMultipla || criar">
      <SGPFormCheckboxComponent v-if="selecaoMultipla" label="Selecionar Tudo" class="margin-left-17"
        @input="selecionarTudo" v-model="checkSelecionarTudo" />

      <div v-if="criar" class="d-flex justify-center align-center prepend-criar-item">
        <button class="text-grey text-caption btn-criar-designacao" @click.stop="onCriar" :changeText="changeText">
          {{ changeText }}
          <v-icon small class="ml-1 text-black">mdi-plus</v-icon>
        </button>
      </div>

      <v-divider v-if="selecaoMultipla || criar" />
    </template>

    <template v-slot:selection="{ item, index }" v-if="!exibirQtdSelecionados">
      <v-chip v-if="index === 0 && formatoBotao">
        <span>{{ item[optionLabel] }}</span>
      </v-chip>
      <span v-if="index === 0" class="pt-2">{{ item[optionLabel] }}</span>
      <span v-if="value.length >= 1 && index === 0" class="d-block full-width grey--text text-caption">
        (
        <span v-if="value.length > 0">+{{ value.length - 1 }} </span>
        selecionado)
      </span>
    </template>


    <template v-slot:item="{ item }">
      <div class="d-flex justify-space-between align-center w-100">
        <span class="text-grey text-caption">{{ item[optionLabel] }}</span>

        <button
          v-if="editar"
          class="text-grey text-caption ml-4 btn-editar-designacao"
          @click.stop="onEditar(item)"
        >
          Editar
        </button>
      </div>
    </template>

  </v-autocomplete>
</template>

<script>
export default {
  name: 'SGPFormAutocompleteComponent',

  props: {
    error: {
      type: String
    },
    value: {
      // type: Object,
      required: true
    },
    validate: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    listaDeOptions: {
      type: Array,
      required: true,
    },
    optionLabel: {
      type: String,
      required: false,
      default: 'name'
    },
    optionValue: {
      type: String,
      required: false,
      default: 'id'
    },
    somenteLeitura: {
      type: Boolean,
      required: false,
      default: false
    },
    optionSelecione: {
      type: String,
      required: false,
      default: 'Selecione'
    },
    autoSelectFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    limpavel: {
      type: Boolean,
      required: false,
      default: false
    },
    selecaoMultipla: {
      type: Boolean,
      required: false,
      default: false
    },
    formatoBotao: {
      type: Boolean,
      required: false,
      default: false
    },
    formatoBotaoExcluir: {
      type: Boolean,
      required: false,
      default: false
    },
    sobrescreverOption: {
      type: Boolean,
      required: false,
      default: false
    },
    exibirQtdSelecionados: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: undefined
    },
    editar: {
      type: Boolean,
      required: false,
      default: false
    },
    criar: {
      type: Boolean,
      required: false,  
      default: false
    },
    changeText: {
      type: String,
      required: false,
      default: 'Adicionar'
    }
  },

  data() {
    return {
      listaDeOptionsAuxiliar: [],
      loadingInternal: false,
      checkSelecionarTudo: false,
    }
  },

  created() {
    if (this.sobrescreverOption) {
      this.listaDeOptionsAuxiliar = this.listaDeOptions.length ? this.listaDeOptions : [];
    }
  },

  mounted() {
    // if (this.modelData.length == this.listaDeOptions.length) {
    //   this.checkSelecionarTudo = true
    // }
  },

  methods: {
    parseValue(e) {
      if (this.sobrescreverOption) {
        if (e.target.value == '') {
          this.listaDeOptionsAuxiliar = this.listaDeOptions;
          return
        }
        this.modelData = e.target.value;
        this.listaDeOptionsAuxiliar = [
          { [this.optionValue]: e.target.value }
        ]
      }
    },
    handleChange(e) {
      this.$emit('change', e);
      this.modelData = e;
    },

    selecionarTudo(e) {
      if (e) {
        this.modelData = this.listaDeOptions.map(o => {
          if (this.optionValue) {
            return o[this.optionValue]
          }
          return o.value
        })
        this.loadingInternal = false
        this.$emit('selecionaTodos', e);
        return
      }
      this.modelData = ''
      this.listaDeOptionsAuxiliar = []
      this.$emit('selecionaTodos', e);
    },
    onEditar(e) {
      this.$emit('editarSelecionado', e);
    },
    onCriar() {
      this.$emit('criarSelecionado');
    },
  },

  computed: {
    modelData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    loadingProp() {
      return this.loading !== undefined ? this.loading : this.loadingInternal;
    }
  },

  watch: {
    value() {
      if (this.value.length == this.listaDeOptions.length) {
        this.checkSelecionarTudo = true
        return
      }
      this.checkSelecionarTudo = false
    }
  }
}
</script>

<style lang="scss">
.hide-error.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}

.btn-criar-designacao {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 95%;
  margin-top: 5px;
  padding: 6px 10px;

  border: 1px solid #f44336;
  border-radius: 4px;

  background: transparent;
  color: #f44336;

  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;

  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: #f44336;
    border-color: #f44336;
    color: #fff;
  }

  &:active {
    transform: scale(0.99);
  }
}

.btn-editar-designacao {
  border: 1px solid red;
  border-radius: 4px;
  padding: 2px 6px;
  background: transparent;
  color: black;
}

.prepend-criar-item {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
}
</style>
